import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { s__ } from '@design-system/i18n';
export const OrderSummaryEmpty = () => (_jsx(Box, { mb: 4, children: s__('ShoppingCard|Your cart is empty') }));
//# sourceMappingURL=OrderSummaryEmpty.js.map